export function getDictionaryFieldContextInitialState() {
    return {
        contextValues: {},
    };
}
